import React from 'react';
import KnowledgeHubDrawerContent from './components/KnowledgeHubDrawerContent.jsx';
import { useSources } from '../../application/sources/provider';

/** Drawer rendering consumes application source state and commands only. */
export const KnowledgeDrawer = ({ resolvedUILabels, handleOpenSourcePicker }) => {
  const sources = useSources();
  return <KnowledgeHubDrawerContent
    resolvedUILabels={resolvedUILabels}
    sourceUploadLoading={sources.sourceUploadLoading}
    sourceSyncLoading={sources.sourceSyncLoading}
    sourceActionError={sources.sourceActionError}
    sourceItems={sources.sourceItems}
    sourceUploadProgressItems={sources.sourceUploadProgressItems}
    handleOpenSourcePicker={handleOpenSourcePicker}
    handleRemoveSource={sources.handleRemoveSource}
    handleViewSourceDetail={sources.handleViewSourceDetail}
  />;
};
